import { render, staticRenderFns } from "./InitializeSucceed.vue?vue&type=template&id=0dfca4a3&scoped=true&"
import script from "./InitializeSucceed.vue?vue&type=script&lang=ts&"
export * from "./InitializeSucceed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfca4a3",
  null
  
)

export default component.exports